import { render, staticRenderFns } from "./BudgetSuggestion.vue?vue&type=template&id=2af5a275&scoped=true"
import script from "./BudgetSuggestion.vue?vue&type=script&lang=js"
export * from "./BudgetSuggestion.vue?vue&type=script&lang=js"
import style0 from "./BudgetSuggestion.vue?vue&type=style&index=0&id=2af5a275&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af5a275",
  null
  
)

export default component.exports